<script lang="ts">
  import { onMount } from "svelte";
  import { initSubtasksList, records, submission } from "./task-subtask.store";
  import { ChallengePage } from "./challenge-tab";
  import TaskSubmissionLayout from "./TaskSubmissionLayout.svelte";

  export let sectionId: number;
  export let challengeId: number;
  export let submissionId: number;

  onMount(() => initSubtasksList(sectionId, challengeId, submissionId));
</script>

<TaskSubmissionLayout {sectionId} {challengeId} currentTab={ChallengePage.Submissions} submissionResults={true}>
  {#if $submission}
    {#if $submission.compilation == 0}
      <div class="submission-stats content box">
        <h2 class="subtitle">Compilation Diagnostics</h2>
        <pre class="compilation-diagnostics">{$submission.diagnostics}</pre>
      </div>
    {:else}
      <div class="submission-stats content box">
        <h2 class="subtitle">Submission Results</h2>

        <table class="submissions-table">
          <tr>
            <th>Subtask</th>
            <th>Execution</th>
            <th>Points</th>
            <th>Run Time (ms)</th>
            <th>Outcome</th>
          </tr>
          {#if $records}
            {#each $records as task}
              <tr>
                <td>{task.order}</td>
                <td><i class="material-icons">{task.executionOk === 1 ? "check" : "close"}</i></td>
                <td>{task.points} / {task.maxPoints}</td>
                <td>{task.runtimeMs >= 0 ? task.runtimeMs : "//"}</td>
                <td>{task.runtimeMs >= 0 ? (task.resultsOk === 1 ? "OK" : "Wrong output") : "Timeout"}</td>
              </tr>
            {/each}
            {#if $records.length == 0}
              <tr>
                <td colspan="5" class="has-text-centered">no data</td>
              </tr>
            {/if}
          {/if}
        </table>
      </div>
    {/if}
  {/if}
</TaskSubmissionLayout>

<style>
  .submission-stats {
    position: relative;
  }

  .compilation-diagnostics {
    background-color: transparent;
  }

  .submissions-table {
    border: 1px solid #ccc;
  }
</style>
